import { deleteE2EScenarioTeardown, getE2EEstates, getE2EScenarios, postE2EScenarioJob } from '@/api/admin.api';
import type { E2EScenarioName } from '@condo/domain';
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query';
import { computed, unref, type MaybeRef } from 'vue';

export const useE2EEstates = (paramsOrRef: MaybeRef<{ page: number; size: number }>) => {
    const params = computed(() => unref(paramsOrRef));
    return useQuery(
        ['e2e-estates', params],
        async () => {
            const p = params.value;
            const result = await getE2EEstates({ page: p.page, size: p.size });
            return result;
        },
        {
            initialData: { estates: [], total: 0 },
        },
    );
};

export const useE2EScenarios = () => {
    return useQuery(['e2e-scenarios'], async () => getE2EScenarios(), {
        initialData: {} as Record<string, E2EScenarioName[]>,
    });
};

export const usePostE2EScenarioJob = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async ({ scenarioName, params }: { scenarioName: string; params?: Record<string, any> }) => {
            return postE2EScenarioJob(scenarioName, { params });
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(['e2e-estates']);
            },
        },
    );
};

export const useTeardownE2EScenario = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async ({ scenarioName, token }: { scenarioName: string; token: string }) => {
            return deleteE2EScenarioTeardown(scenarioName, token);
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(['e2e-estates']);
            },
        },
    );
};
